var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20375",
    "data-name": "Group 20375",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.892,
    height: 20.027,
    viewBox: "0 0 33.892 20.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90508",
    "data-name": "Path 90508",
    d: "M12.013,30.027H25.878A10.013,10.013,0,0,0,35.892,20.013h0A10.013,10.013,0,0,0,25.878,10H12.013A10.013,10.013,0,0,0,2,20.013H2A10.013,10.013,0,0,0,12.013,30.027Z",
    transform: "translate(-2 -10)",
    fill: "#0ad85f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1399",
    "data-name": "Ellipse 1399",
    cx: 8.473,
    cy: 8.473,
    r: 8.473,
    transform: "translate(14.635 1.541)",
    fill: "#eceff1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleButton);
export default __webpack_public_path__ + "static/media/toggleButton.250b5977f9d58110e2ee71e801e7970a.svg";
export { ForwardRef as ReactComponent };